import { readHiddenListFile, writeHiddenListFile } from './hiddenListFile';

/** Hidden JSON file (in the tool folder) that carries the saved slugs. */
export const SAVED_TEMPLATES_FILE = 'genai-saved-templates.json';

/** Drive file attribute holding the saved slugs. See `hiddenListFile`. */
export const SAVED_TEMPLATES_ATTR = 'genai~savedTemplates';

export interface SavedTemplates {
  slugs: string[];
  /** Drive file id, or null when the file hasn't been created yet. */
  fileId: string | null;
}

export const getSavedTemplates = async ({
  toolId,
}: {
  toolId: string;
}): Promise<SavedTemplates | null> => {
  const stored = await readHiddenListFile({
    toolId,
    fileName: SAVED_TEMPLATES_FILE,
    attribute: SAVED_TEMPLATES_ATTR,
  });

  return stored ? { slugs: stored.values, fileId: stored.fileId } : null;
};

export const saveTemplates = ({
  toolId,
  slugs,
  fileId,
}: {
  toolId: string;
  slugs: string[];
  fileId: string | null;
}): Promise<{ fileId: string | null } | null> =>
  writeHiddenListFile({
    toolId,
    fileName: SAVED_TEMPLATES_FILE,
    attribute: SAVED_TEMPLATES_ATTR,
    values: slugs,
    fileId,
  });
